// extracted by mini-css-extract-plugin
export default {"spinner":"Wf","sk-rotate":"Xf","skRotate":"Xf","dot1":"Yf","dot2":"Zf","sk-bounce":"_f","skBounce":"_f"};